/**
 * Iter-62.3.1 / Iter-62.3.2 — canonical public-form validators shared by:
 *   - Standard `LandingForm.jsx`
 *   - `QuizForm.jsx` (still re-exports for backwards compat)
 *   - `FocusedFunnelForm.jsx`
 *
 * `EMAIL_RE` matches the backend `EmailStr` permissive `local@domain`
 * check plus a 254-char upper bound. `ZIP_RE` matches the U.S. 5-digit
 * or 5+4 ZIP format the platform already stores.
 *
 * These validators are the single source of truth for the canonical
 * public-contact policy (First / Last / Phone / Email / State / ZIP /
 * TCPA consent required on every consumer-facing form experience).
 *
 * Iter-62.3.2: phone display / normalization / validation lives in
 * `publicFormPhone.js` and is re-exported here so callers can pull
 * every public-form contact-step validator from one module.
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const ZIP_RE = /^\d{5}(-\d{4})?$/;

export function isValidEmail(s) {
  const v = (s || "").trim();
  return v.length > 0 && v.length <= 254 && EMAIL_RE.test(v);
}

export function isValidZip(s) {
  const v = (s || "").trim();
  return v.length > 0 && ZIP_RE.test(v);
}

export {
  formatUSPhone,
  normalizeUSPhoneDigits,
  isValidUSPhone,
} from "./publicFormPhone";

// ---------------------------------------------------------------------------
// Iter-62.3.2 — canonical incident-age timing vocabulary + labels.
//
// The five consumer-facing windows every public form experience now
// shares (Standard, Quiz, Focused Funnel). Backend routing consumes
// these on `extra.incident_age_bucket` via `buyer_eligibility.py`
// (`QUIZ_BUCKET_DAYS`). Do NOT fabricate an ISO `incident_date` from
// a bucket — leave `incident_date` null when only the bucket is known.
// ---------------------------------------------------------------------------
export const INCIDENT_AGE_BUCKETS = [
  { value: "within_30_days",    label: "Within 30 days" },
  { value: "31_to_60_days",     label: "Within 60 days" },
  { value: "61_to_90_days",     label: "Within 90 days" },
  { value: "91_days_to_1_year", label: "Within 1 year" },
  { value: "over_1_year",       label: "Over 1 year" },
];

export const INCIDENT_AGE_BUCKET_VALUES = INCIDENT_AGE_BUCKETS.map(
  (b) => b.value,
);
